<template>
  <div>
    <breadcrumbs home="Batch item moves" :back="[{text:'Items',to:{name:'InventoryItems'}}]"/>

<!--
    <inventory-items-bulk-move-import v-model="importBulkMove" @refresh="$refs.table.buildList()"/>
    -->

    <purtrak-table name="batchitemmoves" objectType="batch moves" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   listEndPoint="itemsBatchMoves"
                   fields="id,date,draft,status,comments,shipVia"
                   :listFilters="listFilters"
                   @dblclick="move => $router.push({name:'InventoryItemsBatchMoveEdit',params:{id:move.id}})"
                   :item-class="move => (move.draft ? 'warning--text' : '')"
                   title="Batch Moves"
                   :print-info="{subTitle:[filters.from?dateDisplay:'',filters.draft=='1'?'Draft':'',filters.status?'Status: ' + filters.status : '']}"
                   download-endpoint="itemsBatchMovesExportCSV">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.draft='0';filters.from=null;filters.to=null;filters.status=''">
          <v-list-item>
            <filter-search label="Status" v-model="filters.status"/>
          </v-list-item>
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item>
            <v-checkbox v-model="filters.draft" true-value="1" false-value="0" label="Draft only" class="mt-0"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.status!=''" close small class="ml-1" @click:close="filters.status=''">Status: {{filters.status}}</v-chip>
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="filters.draft=='1'" close small class="ml-1" @click:close="filters.draft='0'">Draft only</v-chip>
        </template>
      </template>
      <template v-slot:menu v-if="!readOnly">
        <v-list-item :to="{name:'InventoryItemsBatchMoveEditNew'}"><v-list-item-title>Create batch move</v-list-item-title></v-list-item>
<!--
        <v-divider/>
        <v-list-item v-if="!$vuetify.breakpoint.mobile" @click="importBulkMove=true"><v-list-item-title>Import batch item move from CSV</v-list-item-title></v-list-item>
-->
      </template>
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'InventoryItemsBatchMoveEditNew'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.date="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.draft="{value,printing}">
        <template v-if="printing">{{value?'Y':''}}</template>
        <v-icon v-else-if="value">mdi-check</v-icon>
      </template>
      <template v-slot:item.status="{item}">
        {{item.status}}
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item :to="{name:'InventoryItemsBatchMoveEdit',params:{id:item.id}}"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <v-menu :nudge-left="175" v-if="item.shipVia">
              <template v-slot:activator="{on:print}">
                <v-list-item v-on="print">
                  <v-list-item-title>Print</v-list-item-title>
                  <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
                </v-list-item>
              </template>
              <v-list dense>
                <v-list-item @click="printForm('packingList', item)"><v-list-item-title>Print packing list</v-list-item-title></v-list-item>
                <v-list-item @click="printForm('BOL', item)"><v-list-item-title>Print bill of lading</v-list-item-title></v-list-item>
              </v-list>
            </v-menu>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item :to="{name:'InventoryItemsBatchMoveEditNew',params:{copyId:item.id}}"><v-list-item-title>Copy move</v-list-item-title></v-list-item>
              <v-list-item @click="batchMove=item;showDelete=true"><v-list-item-title>Delete</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" name="this batch move" @delete="performDeleteTransaction"/>
  </div>
</template>

<script>
//import InventoryItemsBulkMoveImport from '@/views/inventory/items/InventoryItemsBulkMoveImport'
import printBOL from '@/views/sales/shipments/printBOL'
import SalesShipmentsPrintPackingListHTML from '@/views/sales/shipments/SalesShipmentsPrintPackingListHTML'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'InventoryItemsBatchMove',
  mixins: [printBOL,SalesShipmentsPrintPackingListHTML,printHtml],
//  components: {InventoryItemsBulkMoveImport},
  data() {
    return {
      filters: {
        status: '',
        from: null,
        to: null,
        draft: '0'
      },
      dateDisplay: '',
      batchMove: {},
      showDelete: false,
      importBulkMove: false,
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'draft', visible:true},
                       { value: 'status', visible:true},
                       { value: 'comments', visible:false}],
      headers: [{ text: 'DATE', value: 'date', width:'15%',sortable:true},
                { text: 'DRAFT', value: 'draft', width:'15%',sortable:true, align:'center'},
                { text: 'STATUS', value: 'status', width:'50%',sortable:true},
                { text: 'COMMENTS', value: 'comments', width:'50%',sortable:false}]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    readOnly() {
      return !this.company.permissions.includes('inventory.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    listFilters() {
      const filters = [];
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      if (this.filters.status)
        filters.push({field:'status', comparator:'contains', value:this.filters.status});
      if (this.filters.draft === '1')
        filters.push({field:'draft', comparator:'eq', value:'true'});

      return filters;
    }
  },
  methods: {
    async performDeleteTransaction() {
      this.loading = true;
      const results = await this.$apiCall(`mutation InventoryItemsBatchMove($id: ID!) {
                                            objectDelete(id:$id)
                                          }`,
                                          {id:this.batchMove.id});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        this.$store.commit('setError', {type:'success',message:`Deleted batch item move`});
        this.$refs.table.buildList();
      }
    },
    async printForm(form, item) {
      const items = [];
      await this.$lazyListLoad(items, 'items2', 'id,sku,name,precision,trackUnits,weight', 100);
      let results = await this.$apiCall(`query InventoryItemsBatchMove($id:ID!) {
                                             itemsBatchMove(id:$id) {
                                                date,number,shipVia,defaultFromSiteId,defaultToSiteId
                                                pallets,specialInstructions
                                                items {itemId,quantity}
                                              }
                                            }`,
                                          {id:item.id});
      if (results.error)
        return;
      const move = results.data.itemsBatchMove;

      results = await this.$apiCall(`query InventoryItemsBatchMove($fromSiteId:ID!, $tositeId:ID!) {
                                        shipFrom:site(id:$fromSiteId) {
                                          name,shippingAddress
                                        }
                                        shipTo:site(id:$tositeId) {
                                          name,shippingAddress
                                        }
                                        company {name,address,city,province,postalCode,email,phone,logoURL}
                                      }`,
                                    {fromSiteId:move.defaultFromSiteId, tositeId:move.defaultToSiteId});
      if (results.error)
        return;

      const shipFrom = results.data.shipFrom;
      const shipTo = results.data.shipTo;
      const shipperAddress = `${shipFrom.name}\n${shipFrom.shippingAddress}`;
      const shipToAddress = `${this.$store.getters.company.name}\n${shipTo.name}\n${shipTo.shippingAddress}`;
      const lines = [];
      for (const line of move.items) {
        const item = items.find(item => item.id === line.itemId);
        lines.push({sku:item.sku,description:item.name,quantity:line.quantity,
                    precision:item.precision,units:item.trackUnits,
                    weight:line.quantity * item.weight});
      }
      if (form === 'BOL') {
        const bol =  {shipperName:this.$store.getters.company.name,
                    shipperAddress, shipToAddress,
                    referenceNumber:move.number, date:move.date,
                    shipVia:move.shipVia, pallets:move.pallets, specialInstructions:move.specialInstructions,
                    lines};
        this.printBOL(bol);
      }
      else {
        const company = results.data.company;
        const shipment = {date:move.date,shipVia:move.shipVia,pallets:move.pallets,memo:'',invoiceNumber:'',shipToAddress,
                          billToAddress:`${company.name}\n${company.address}\n${company.city} ${company.province}  ${company.postalCode}`,
                          lines};
        this.printHtml('Packing list',this.print(company, shipment), company.logoURL ? {id:'logo', src:company.logoURL} : null);
      }
    }
  }
}
</script>